// extracted by mini-css-extract-plugin
export default {"ratingList":"TeachersRatings_ratingList__EYJcW","list":"TeachersRatings_list__i3f0W","empty":"TeachersRatings_empty__s1gbV"};